// extracted by mini-css-extract-plugin
export default {"Comments":"styles_Comments__U507g","commentsContainer":"styles_commentsContainer__DyfYe","scrollable":"styles_scrollable__JNeqU"};